import { mapGetters } from 'vuex'

import data from '@/mixins/data'
import methods from '@/mixins/methods'

import TitleAnimation from '@/components/ui/title-animation'
import LinkAnimation from '@/components/ui/link-animation'
import TextAnimation from '@/components/ui/text-animation'
import HashtagAnimation from '@/components/ui/hashtag-animation'
import ImageAnimation from '@/components/ui/image-animation'
import CaseLinkAnimation from '@/components/ui/case-link-animation'
import WebglHeader from '@/components/ui/webgl-header'
import Wysiwyg from '@/components/wysiwyg'

export default {
  mixins: [data, methods],
  components: {
    TitleAnimation,
    LinkAnimation,
    TextAnimation,
    HashtagAnimation,
    ImageAnimation,
    CaseLinkAnimation,
    WebglHeader,
    Wysiwyg
  },
  created () {
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    this.mobile = this.$store.state.ua.platform.type !== 'desktop' || isSafari
  }
}
